import { IonSkeletonText } from "@ionic/react";
import React from "react";

const Skeleton__OrderBook: React.FC = () => {
  return (
    <div style={{ margin: "8px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 13,
          width: "100%",
        }}
      >
        <IonSkeletonText
          animated={true}
          style={{ width: "20%", height: "38px" }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ width: "40%", height: "38px" }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ width: "40%", height: "38px" }}
        ></IonSkeletonText>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          width: "100%",
        }}
      >
        <IonSkeletonText
          animated={true}
          style={{ width: "20%", height: "28px", borderRadius: "20px" }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ width: "20%", height: "28px", borderRadius: "20px" }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ width: "20%", height: "28px", borderRadius: "20px" }}
        ></IonSkeletonText>
        <IonSkeletonText
          animated={true}
          style={{ width: "20%", height: "28px", borderRadius: "20px" }}
        ></IonSkeletonText>
      </div>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
    </div>
  );
};

export default Skeleton__OrderBook;
